import React, { type JSX } from "react";
import SVG from "react-inlinesvg";
import { ChatLink } from "tsi-common-react/src/components/ChatLink/index";
import { RichText } from "tsi-common-react/src/components/RichText/index";
import { usePageSetting } from "tsi-common-react/src/utils/settings";
import { usePageURL } from "tsi-common-react/src/utils/urls";
import { t } from "ttag";

import iconSpeechBubblesTalk from "../../../assets/svg/speech-bubbles-talk.svg";

export const CheckoutSidebarContent = (): React.ReactNode => {
    const contactURL = usePageURL("contact_us_form");
    const homeURL = usePageURL("home");
    const enableCheckoutSidebarQuestionsBlock = usePageSetting(
        "enable_checkout_sidebar_questions_block",
    );
    const checkoutSidebarExtraContent = usePageSetting(
        "checkout_sidebar_extra_content",
    );
    let questionsBlock: JSX.Element | null = null;
    if (enableCheckoutSidebarQuestionsBlock) {
        questionsBlock = (
            <div className="basket-summary__help">
                <h3>
                    <SVG
                        className="basket-summary__help-icon"
                        src={iconSpeechBubblesTalk}
                        title={t`Speech Bubbles Icon`}
                    />
                    {t`Questions?`}
                </h3>
                <div className="basket-summary__text">
                    <ChatLink
                        className="basket-summary__help--link basket-summary__help--link-checkout "
                        chatOfflineLink={contactURL || homeURL}
                    />
                    <br />
                </div>
            </div>
        );
    }
    return (
        <div className="basket-summary__sidebar-content">
            {questionsBlock}
            <RichText html={checkoutSidebarExtraContent || ""} />
        </div>
    );
};
